import React from 'react'


const PrivacyPolicyForLive = () => {
  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif", lineHeight: "1.6" }}>
      <h1 style={{ textAlign: "center", marginBottom: "20px" }}>Privacy Policy</h1>
      
      <p>Welcome to Axcell Painting! We value your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, and protect your data when you use our application.</p>
      
      <h2>Information We Collect</h2>
      <p>When you register for an account or use our services, we may collect the following information:</p>
      <ul>
        <li><strong>Personal Details:</strong> Name, email address, phone number, and address.</li>
        <li><strong>Payment Information:</strong> Billing details for subscription or one-time payments (processed securely).</li>
        <li><strong>Task Details:</strong> Completion of project, working ours, and progress tracking.</li>
        <li><strong>Device Information:</strong> IP address, browser type, and operating system for analytics purposes.</li>
      </ul>
      
      <h2>How We Use Your Information</h2>
      <p>Your information is used to:</p>
      <ul>
        <li>Provide and manage your account.</li>
        <li>Track your work progress and goals.</li>
        <li>Send invoice aprovals and rejections.</li>
        <li>Process payments securely.</li>
        <li>Improve our services and provide customer support.</li>
      </ul>
      
      <h2>Sharing Your Information</h2>
      <p>We do not share your personal information with third parties except:</p>
      <ul>
        <li>With service providers who help us process payments or manage data (e.g., payment gateways).</li>
        <li>To comply with legal obligations or protect the safety and rights of others.</li>
      </ul>
      
      <h2>Data Security</h2>
      <p>We use industry-standard security measures to protect your data, including encryption, secure servers, and access controls. However, no system is 100% secure, and we cannot guarantee absolute protection.</p>
      
      <h2>Your Rights</h2>
      <p>You have the right to:</p>
      <ul>
        <li>Access, update, or delete your personal information.</li>
        <li>Opt-out of receiving marketing communications.</li>
        <li>Request a copy of your stored data.</li>
      </ul>
      <p>To exercise these rights, please contact us at <a href="mailto:axcellpainting@gmail.com">axcellpainting@gmail.com</a>.</p>
      
      <h2>Changes to This Privacy Policy</h2>
      <p>We may update this policy from time to time to reflect changes in our practices or for other operational, legal, or regulatory reasons. Any updates will be posted in the app, and your continued use of the app constitutes acceptance of these changes.</p>
      
      <p>If you have any questions about this privacy policy, please contact us at <a href="mailto:axcellpainting@gmail.com">axcellpainting@gmail.com</a>.</p>
    </div>
  );
};

export default PrivacyPolicyForLive;

